export const DEFAULT_ERROR_MESSAGE = "Something went wrong. Please contact support.";

export const isFiniteCoordinate = (value: string | number | null | undefined): boolean => {
    if (value === null || value === undefined) {
        return false;
    }

    if (typeof value === "string" && value.trim() === "") {
        return false;
    }

    return Number.isFinite(Number(value));
};

export const hasGeoCoordinates = (
    geoLat: string | number | null | undefined,
    geoLong: string | number | null | undefined,
): boolean => isFiniteCoordinate(geoLat) && isFiniteCoordinate(geoLong);

export const parseCoordinate = (value: string | number | null | undefined): number | null => {
    if (!isFiniteCoordinate(value)) {
        return null;
    }

    return Number(value);
};

export const getDefaultMessageForStatus = (status: number): string => {
    const statusMessages: Record<number, string> = {
        400: "Bad request. Please check your input.",
        403: "You don't have permission to perform this action.",
        404: "The requested resource was not found.",
        422: "Validation failed. Please check your input.",
        429: "Too many requests. Please try again later.",
        500: "Internal server error. Please try again later.",
        502: "Bad gateway. Please try again later.",
        503: "Service unavailable. Please try again later.",
        504: "Gateway timeout. Please try again later.",
    };

    return statusMessages[status] || DEFAULT_ERROR_MESSAGE;
};

export const isForbiddenError = (error: unknown): error is { message?: string; errorCode: 'FORBIDDEN' } =>
    typeof error === 'object' &&
    error !== null &&
    'errorCode' in error &&
    (error as { errorCode?: unknown }).errorCode === 'FORBIDDEN';

export const getApiErrorMessage = (error: unknown, fallback: string = DEFAULT_ERROR_MESSAGE): string => {
    if (error && typeof error === "object" && "message" in error) {
        const message = (error as { message?: unknown }).message;
        if (typeof message === "string" && message.trim()) {
            return message;
        }
    }

    if (error instanceof Error && error.message.trim()) {
        return error.message;
    }

    return fallback;
};